import { useEffect } from 'react'

const PIXEL_ID = '1702139741167224'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

function initPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  const n: any = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
  }
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as any[]

  window.fbq = n
  window._fbq = n

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // init y PageView se encolan antes de que cargue el script
  // fbevents.js los ejecutará en orden al cargar
  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(e?: React.MouseEvent<HTMLAnchorElement>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Casa Sin Olor: Protocolo 7 Días',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}

export function useMetaPixel() {
  useEffect(() => {
    initPixel()
    // PageView se encola después de init — fbevents.js los ejecuta en orden
    trackPageView()
  }, [])
}
